import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import DetailTemplate from '../../common/template/DetailTemplate';
import CostCalcLockContainer from '../../../containers/projectmng/costcalc/CostCalcLockContainer';
import PurchaseBillHistoryContainer from '../../../containers/projectmng/bill_mng/PurchaseBillHistoryContainer';
import SalesBillFormContainer from '../../../containers/projectmng/bill_mng/SalesBillFormContainer';
import SalesBillHistoryContainer from '../../../containers/projectmng/bill_mng/SalesBillHistoryContainer';
import BillPlanReplanContainer from '../../../containers/projectmng/billplan/BillPlanReplanContainer';
import { ENTRY_PROJECT } from '../../../lib/api/billReplan';

const SalesBillConfirmReqTemplate = () => {
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <Box
        sx={{
          py: 2,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2" color={'error.main'} component="div">
          받은 발주서 / 보낸 발주서를 업로드 해야 세금계산서 발행이 가능합니다.
          <br />
          작성 여부를 확인하십시오.
        </Typography>
      </Box>
      <DetailTemplate title="원가 산출 내역">
        <CostCalcLockContainer project={project} />
      </DetailTemplate>
      <DetailTemplate title="매입 계산서 매입 등록 내용">
        <PurchaseBillHistoryContainer project={project} />
      </DetailTemplate>
      <DetailTemplate title="매출 계산서 매출 등록 내용">
        <SalesBillHistoryContainer project={project} />
      </DetailTemplate>
      <DetailTemplate title="매출 계산서 발행 요청 내역">
        <SalesBillFormContainer project={project} />
      </DetailTemplate>
      {/*
        세금계산서 재분배(ksm_backend BillPlanReplanService 포팅, 2026-10-21).
        기존에는 "수주품의서 재작성"으로만 분할을 다시 짤 수 있었는데, 그 경로는 발행
        완료·수금 완료된 회차까지 조건 없이 지워버렸다(업무 흐름 점검 2 - 이슈 #3).
        여기서는 발행 확정/결재 진행중 회차는 서버가 잠가서 건드리지 못하고,
        미확정 회차만 다시 나눌 수 있다.
      */}
      <DetailTemplate title="세금계산서 발행계획 재분배">
        <BillPlanReplanContainer prjUuid={project?.prjUuid} entryPoint={ENTRY_PROJECT} />
      </DetailTemplate>
    </Box>
  );
};

export default SalesBillConfirmReqTemplate;
